import React, { useEffect } from 'react';
import { useRouter } from '../hooks/useRouter';
import LenderUgroService from '../services/lender';
import { downloadFile } from '../common/download';
import { toast } from 'react-toastify';
import message from '../constant/message';
import { Context } from '../config/store';

const DownloadLink = () => {
	const router = useRouter();
	const identifier = router.query.identifier;
	const docName = router.query.name;
	const [errors, setErrors] = React.useState(null);
	const { state } = React.useContext(Context);
    const center = {
        padding: '10% 0',
        textAlign: 'center',
        fontWeight: 500,
        fontSize: 'large',
    };

    useEffect(async ()=>{
        try {
            let response = await LenderUgroService.downloadLink({
                type: state.userType,
                identifier,
                responseType: 'blob'
            });
            downloadFile(response?.data, (docName || identifier).replace(/\.[^/.]+$/, ''))
        } catch (err) {
            setErrors(1);
        }
    },[])
	return (
        errors && <div style={center}>File Not Found</div>	
	);
};

export default DownloadLink;
